import { Button, Card, CardContent, CardHeader, CardTitle } from "@repo/ui";
import { Link } from "react-router-dom";

export function Home() {
  return (
    <div>
      <section className="relative overflow-hidden">
        <div className="max-w-6xl mx-auto px-6 py-16 grid md:grid-cols-2 gap-10 items-center">
          <div>
            <h1
              className="text-5xl md:text-6xl font-bold leading-tight mb-4"
              style={{ fontFamily: "var(--font-display)" }}
            >
              Sricha Bloom
            </h1>
            <p className="text-lg text-muted-foreground mb-6">
              A colorful, retro flower shop celebrating the poetry of petals. We craft bouquets with
              love and passion—right here in Velaa Sindhorn Village, Bangkok.
            </p>
            <div className="flex gap-3">
              <Button className="quirky-btn" asChild>
                <Link to="/order">Order Bouquets</Link>
              </Button>
              <Button className="quirky-btn" variant="secondary" asChild>
                <Link to="/booking">Book a Class</Link>
              </Button>
            </div>
          </div>
          <div className="relative">
            <div className="absolute -top-6 -left-6 size-28 rounded-full bg-accent/20 blur-2xl" />
            <div className="absolute -bottom-8 -right-10 size-32 rounded-full bg-secondary/30 blur-2xl" />
            <img
              src="https://storage.stardeck.ai/images/d4f84781-227b-417b-a032-287630240d75.png"
              alt="Sricha Bloom — bouquet and flowers from our shop"
              className="relative z-10 w-full rounded-[1.25rem] border border-border object-cover"
            />
            <span
              className="absolute -bottom-3 -right-3 inline-block rounded-full px-3 py-2 text-xs font-medium z-20"
              style={{
                background: "#FFBF00",
                color: "#1a1a1a",
                boxShadow: "0 6px 0 rgba(0,0,0,0.1)",
              }}
            >
              Join the Local Market
            </span>
          </div>
        </div>
      </section>

      <section className="bg-muted/40 border-y border-border">
        <div className="max-w-6xl mx-auto px-6 py-14 grid md:grid-cols-3 gap-6">
          <Card>
            <CardHeader>
              <CardTitle>Love in Every Stem</CardTitle>
            </CardHeader>
            <CardContent className="text-sm text-muted-foreground">
              Every bouquet is arranged by hand with care, rhythm, and a little bit of old-school
              flair.
            </CardContent>
          </Card>
          <Card>
            <CardHeader>
              <CardTitle>Bright & Retro</CardTitle>
            </CardHeader>
            <CardContent className="text-sm text-muted-foreground">
              Bold yellows, reds, and blues lead our palette—nostalgic colors for timeless feelings.
            </CardContent>
          </Card>
          <Card>
            <CardHeader>
              <CardTitle>Bangkok Roots</CardTitle>
            </CardHeader>
            <CardContent className="text-sm text-muted-foreground">
              Nestled in Velaa Sindhorn Village, we’re your neighborhood bloom studio from dawn to
              late.
            </CardContent>
          </Card>
        </div>
      </section>
    </div>
  );
}
